import React, {FC} from 'react';
import styled from 'styled-components';
import {Helmet} from 'react-helmet';
import ReactSlick from 'react-slick';

import {StylableProps} from '../../../lib/styleHelpers';
import {palette, tabletBreakpoint} from '../../../lib/styleVariables';
import {convertHexToRGBA} from '../../../lib/color-utils';

const sliderSettings = {
  touchThreshold: 20, // the user must swipe a length of (1/touchThreshold) * the width of the slider
  arrows: false,
  autoplay: false,
  autoplaySpeed: 7000,
  dots: true,
  draggable: true,
  centerMode: true,
  centerPadding: '4px',
  variableWidth: true,
  infinite: true,
  responsive: [
    {
      breakpoint: tabletBreakpoint,
      settings: {
        adaptiveHeight: true
      }
    }
  ]
};

interface SliderProps {
  rowCount: number;
  items: any;
  showGlimpseOnSides?: boolean;
}

const StyledSlider = styled(ReactSlick)<{isShowGlipse?: boolean}>`
  width: 100%;

  .slick-track {
    display: flex;
  }

  .slick-slide {
    width: ${props => (props.isShowGlipse ? '296px' : '100%')};
    padding-left: 4px;
    padding-right: 4px;
  }

  .slick-dots {
    height: 10px;
    display: flex !important;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    li {
      width: auto;
      height: auto;
      margin: 0 4px;
      button {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: ${convertHexToRGBA(palette.black.base, 0.1)};
        text-indent: -9999px;
      }
      button:before {
        display: none;
      }
      &.slick-active button {
        background: ${palette.black.base};
      }
    }
  }
`;

// TODO: find a way to import slick css from node_modules (e.g. import('../react-slick/...css'))
export const Slider: FC<SliderProps & StylableProps> = props => {
  const {showGlimpseOnSides} = props;

  return (
    <>
      <Helmet
        link={[
          {
            rel: 'stylesheet',
            type: 'text/css',
            href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css'
          },
          {
            rel: 'stylesheet',
            type: 'text/css',
            href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css'
          }
        ]}
      />
      <StyledSlider
        {...sliderSettings}
        rows={props.rowCount}
        className={props.className}
        isShowGlipse={showGlimpseOnSides}
      >
        {props.items}
      </StyledSlider>
    </>
  );
};
